export default "__VITE_ASSET__DmSbuS1f__"